/* eslint-disable prefer-const */
import { useReportTourExport } from 'api-hooks/report';
import { Spinner } from 'baseui/spinner';
import { DownloadSVG } from 'common/assets';
import notification from 'components/common/notification';
import { Button } from 'components/elements/buttons';
import { format } from 'date-fns';
import * as FileSaver from 'file-saver';
import useTranslation from 'next-translate/useTranslation';
import * as React from 'react';

function dataURLtoFile(dataurl, filename) {
  let arr = dataurl.split(','),
    mime = arr[0].match(/:(.*?);/)[1],
    bstr = atob(arr[1]),
    n = bstr.length,
    u8arr = new Uint8Array(n);

  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }

  return new File([u8arr], filename, { type: mime });
}

export default function ExportTourDetailButton(props: { tourRefId: string }) {
  const { t } = useTranslation();
  const { mutateAsync, isLoading } = useReportTourExport();

  const onDownload = async () => {
    try {
      const result = await mutateAsync({
        tourRefId: props.tourRefId,
      });
      const exportName = `report-tour-detail-${format(
        new Date(),
        'dd-mmm-yyyy',
      )}`;
      if (result) {
        const resultFile = dataURLtoFile(result, exportName);
        FileSaver.saveAs(resultFile, exportName);
      }
    } catch (error) {
      notification.error({ message: error.message });
    }
  };

  return (
    <Button
      buttonType="tertiary"
      disabled={isLoading}
      startEnhancer={(color, size) =>
        isLoading ? (
          <Spinner color={color} $size={size} />
        ) : (
          <DownloadSVG color={color} size={size} />
        )
      }
      onClick={onDownload}
      style={{ minWidth: 200 }}
    >
      {t('report:download_report')}
    </Button>
  );
}
